// extracted by mini-css-extract-plugin
export default {"close":"index_close_zgAbP","num":"index_num_4kEUq","current":"index_current_YKzN5","total":"index_total_m2oyh"};